module.exports = __webpack_public_path__ + "img/yx4-en.333afe64.jpg";